import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { first, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { isMaintenanceWindowUrl, MAINTENANCE_WINDOW_PATH } from 'src/shared/constants/maintenance-window.constants';
import { MaintenanceWindowService } from 'src/shared/services/maintenance-window/maintenance-window.service';

/**
 * Stops the flash of a route's real content before `MaintenanceWindowComponent`'s effect can
 * redirect it away: this runs before the route activates, not after it's already rendered.
 * It only covers navigation *into* an active window — the effect (mounted in every app's root
 * component) still handles a window starting or ending while the user is already on a page,
 * since neither of those is a navigation this guard would ever see.
 */
export const maintenanceGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);

  if (isMaintenanceWindowUrl(state.url)) {
    return true; // Already headed there — avoid redirecting the page to itself.
  }

  return inject(MaintenanceWindowService)
    .getCurrentWindow(environment.app)
    .pipe(
      first(),
      map((window) => (window ? new RedirectCommand(router.parseUrl(`/${MAINTENANCE_WINDOW_PATH}`)) : true))
    );
};
